/* ==========================================================================
   PureNode Product Card behaviour — shared across all automated product grids.
   Handles: quantity steppers, AJAX add-to-cart (using the card quantity),
   and the Quick View modal (fetched from /products/{handle}.js).
   Delegated on document so it works for any .pnc-card, regardless of section.
   ========================================================================== */
(function () {
  if (window.__pncCardInit) return;
  window.__pncCardInit = true;

  function money(cents) { return 'A$' + (cents / 100).toFixed(2); }

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pnc-qty-btn');
    if (!btn) return;
    var wrap = btn.closest('.pnc-qty');
    var input = wrap && wrap.querySelector('.pnc-qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(btn.getAttribute('data-step'), 10);
    if (val < 1) val = 1;
    input.value = val;
  });

  /* ---- AJAX add-to-cart (simple products) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pnc-atc-btn[data-pnc-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.pnc-card');
    var qInput = card && card.querySelector('.pnc-qty-input');
    var qty = qInput ? (parseInt(qInput.value, 10) || 1) : 1;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1700);
    })
    .catch(function () { btn.textContent = 'Try again'; btn.disabled = false; });
  });

  /* ---- Quick View modal ---- */
  var modal, mMain, mThumbs, mVendor, mTitle, mPrice, mDesc, mOpts, mCta, mFull, mQn, mExtra, current = null, qty = 1, chosen = [], lastFocus = null, addedView = false, mini = null, miniTimer = null, miniLeft = 10000, miniStart = 0, lastCart = null;

  function buildModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'pnc-qv-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Quick view');
    modal.innerHTML =
      '<div class="pnc-qv-backdrop" data-pnc-qv-close></div>' +
      '<div class="pnc-qv-dialog">' +
        '<div class="pnc-qv-grab" aria-hidden="true"></div>' +
        '<div class="pnc-qv-head">' +
          '<span class="pnc-qv-eyebrow">QUICK VIEW</span>' +
          '<button class="pnc-qv-close" type="button" data-pnc-qv-close aria-label="Close quick view">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="pnc-qv-added" data-m-added hidden>' +
          '<span class="pnc-qv-added-txt"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="5 12 10 17 19 8"/></svg><span data-m-added-txt>Added to cart</span></span>' +
          '<a class="pnc-qv-added-link" href="/cart">View cart \u2192</a>' +
        '</div>' +
        '<div class="pnc-qv-scroll">' +
          '<div class="pnc-qv-media"><img data-m-main src="" alt=""><div class="pnc-qv-thumbs" data-m-thumbs></div></div>' +
          '<p class="pnc-qv-vendor" data-m-vendor></p>' +
          '<h3 class="pnc-qv-title" data-m-title></h3>' +
          '<div class="pnc-qv-price" data-m-price></div>' +
          '<div class="pnc-qv-desc" data-m-desc></div>' +
          '<div data-m-opts></div>' +
          '<div class="pnc-qv-extra" data-m-extra></div>' +
        '</div>' +
        '<div class="pnc-qv-foot">' +
          '<div class="pnc-qv-buy">' +
            '<div class="pnc-qv-qty">' +
              '<button class="pnc-qv-step" type="button" data-m-minus aria-label="Decrease quantity">\u2212</button>' +
              '<span class="pnc-qv-qn" data-m-qn aria-live="polite">1</span>' +
              '<button class="pnc-qv-step" type="button" data-m-plus aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button class="pnc-qv-cta" type="button" data-m-cta></button>' +
          '</div>' +
          '<a class="pnc-qv-full" data-m-full href="#">View full details \u2192</a>' +
        '</div>' +
        '<div class="pnc-qv-mini" data-m-mini aria-hidden="true">' +
          '<div class="pnc-qv-mini-head">' +
            '<span class="pnc-qv-mini-title" role="status" aria-live="polite">Added to your cart <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="5 12 10 17 19 8"/></svg></span>' +
            '<button class="pnc-qv-close" type="button" data-m-mini-close aria-label="Close and return to product">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="pnc-qv-mini-bar" aria-hidden="true"><i data-m-bar></i></div>' +
          '<div class="pnc-qv-mini-body" data-m-mini-body></div>' +
          '<div class="pnc-qv-mini-foot">' +
            '<div class="pnc-qv-mini-btns">' +
              '<button class="pnc-qv-mini-sec" type="button" data-pnc-qv-close>Continue shopping</button>' +
              '<a class="pnc-qv-mini-pri" href="/checkout">Checkout</a>' +
            '</div>' +
            '<a class="pnc-qv-full" href="/cart">View full cart</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    mMain = modal.querySelector('[data-m-main]');
    mThumbs = modal.querySelector('[data-m-thumbs]');
    mVendor = modal.querySelector('[data-m-vendor]');
    mTitle = modal.querySelector('[data-m-title]');
    mPrice = modal.querySelector('[data-m-price]');
    mDesc = modal.querySelector('[data-m-desc]');
    mOpts = modal.querySelector('[data-m-opts]');
    mCta = modal.querySelector('[data-m-cta]');
    mFull = modal.querySelector('[data-m-full]');
    mQn = modal.querySelector('[data-m-qn]');
    mExtra = modal.querySelector('[data-m-extra]');
    modal.querySelector('[data-m-minus]').addEventListener('click', function () { setQty(qty - 1); });
    modal.querySelector('[data-m-plus]').addEventListener('click', function () { setQty(qty + 1); });

    modal.addEventListener('click', function (e) { if (e.target.closest('[data-pnc-qv-close]')) close(); });
    modal.querySelector('[data-m-mini-close]').addEventListener('click', function () { hideMini(true); });
    /* Pause the 10 second countdown while the customer is interacting with the mini-cart. */
    mini = modal.querySelector('[data-m-mini]');
    /* Real interaction pauses it: mouse movement (resumes after 3s of stillness or on leaving), touch, or keyboard focus. */
    var idleT = null;
    mini.addEventListener('mousemove', function () { pauseMini(); clearTimeout(idleT); idleT = setTimeout(resumeMini, 3000); }, { passive: true });
    mini.addEventListener('mouseleave', function () { clearTimeout(idleT); resumeMini(); }, { passive: true });
    mini.addEventListener('touchstart', pauseMini, { passive: true });
    mini.addEventListener('touchend', function () { clearTimeout(idleT); idleT = setTimeout(resumeMini, 3000); }, { passive: true });
    mini.addEventListener('focusin', pauseMini);
    mini.addEventListener('focusout', resumeMini);
    mCta.addEventListener('click', addFromModal);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !modal.classList.contains('is-open')) return;
      if (mini && mini.classList.contains('is-on')) hideMini(true); else close();
    });
  }

  function setQty(n) { qty = Math.max(1, Math.min(99, n)); if (mQn) mQn.textContent = qty; clearAdded(); }

  function open() {
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    document.documentElement.classList.add('pnc-qv-lock');
    var c = modal.querySelector('.pnc-qv-close'); if (c) c.focus();
  }
  function close() {
    stopMini(); if (mini) mini.classList.remove('is-on');
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('pnc-qv-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* keep Tab inside the panel while it is open */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !modal || !modal.classList.contains('is-open')) return;
    var f = Array.prototype.filter.call(modal.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'), function (el) { return !el.closest('[hidden]') && getComputedStyle(el).visibility !== 'hidden'; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function selectedVariant() {
    if (!current) return null;
    if (current.variants.length === 1) return current.variants[0];
    return current.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    }) || null;
  }

  function refreshCta() {
    var v = selectedVariant();
    if (v) {
      mPrice.textContent = money(v.price);
      if (v.available) { mCta.textContent = addedView ? 'Add another' : 'Add to cart'; mCta.disabled = false; mCta.dataset.vid = v.id; }
      else { mCta.textContent = 'Sold out'; mCta.disabled = true; }
    } else { mCta.textContent = 'Unavailable'; mCta.disabled = true; }
  }

  var CHK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><polyline points="8 12 11 15 16 9"/></svg>';
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="6" width="14" height="11" rx="1"/><path d="M15 10h4l3 3v4h-7"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';
  var RET = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="1 4 1 10 7 10"/><path d="M3.5 15a9 9 0 1 0 2.1-9.4L1 10"/></svg>';

  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }

  function buildExtra(p) {
    var tmp = document.createElement('div'); tmp.innerHTML = p.description || '';
    var feats = Array.prototype.slice.call(tmp.querySelectorAll('li')).map(function (li) {
      return (li.textContent || '').replace(/\s+/g, ' ').trim();
    }).filter(function (t) { return t.length > 3 && t.length < 110; }).slice(0, 5);
    var h = '';
    if (feats.length) {
      h += '<div><p class="pnc-qv-h">Key features</p><ul class="pnc-qv-feats">' +
        feats.map(function (t) { return '<li>' + CHK + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul></div>';
    }
    h += '<div data-m-compat></div>';
    h += '<div><ul class="pnc-qv-trust">' +
      '<li>' + TRUCK + '<span>Free shipping on every order</span></li>' +
      '<li>' + RET + '<span>14-day returns</span></li></ul></div>';
    mExtra.innerHTML = h;
    /* compatibility rows come from the product page's own server-rendered pills */
    var url = p.url || ('/products/' + p.handle);
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      if (current !== p) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var rows = [];
      doc.querySelectorAll('.pn-badges .pn-tp-pill').forEach(function (pill) {
        var lb = pill.querySelector('.pn-tp-label');
        var items = Array.prototype.map.call(pill.querySelectorAll('.pn-tp-txt'), function (x) { return x.textContent.trim(); }).filter(Boolean);
        if (lb && items.length) rows.push('<div class="pnc-qv-crow"><span class="pnc-qv-clabel">' + esc(lb.textContent.trim()) + '</span>' +
          items.map(function (i) { return '<span class="pnc-qv-chip">' + esc(i) + '</span>'; }).join('') + '</div>');
      });
      var slot = mExtra.querySelector('[data-m-compat]');
      if (slot && rows.length) slot.innerHTML = '<p class="pnc-qv-h">Compatibility</p><div class="pnc-qv-compat">' + rows.join('') + '</div>';
    }).catch(function () {});
  }

  function render(p) {
    current = p;
    mVendor.textContent = p.vendor || '';
    mTitle.textContent = p.title;
    var dtmp = document.createElement('div'); dtmp.innerHTML = p.description || '';
    var dtxt = (dtmp.textContent || '').replace(/\s+/g, ' ').trim();
    mDesc.textContent = dtxt.length > 240 ? dtxt.slice(0, 237).replace(/\s+\S*$/, '') + '\u2026' : dtxt;
    mFull.href = p.url || ('/products/' + p.handle);
    var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
    if (imgs.length) { mMain.src = imgs[0]; mMain.alt = p.title; }
    mThumbs.innerHTML = '';
    imgs.slice(0, 6).forEach(function (src, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pnc-qv-thumb' + (i === 0 ? ' is-active' : '');
      b.innerHTML = '<img src="' + src + '" alt="">';
      b.addEventListener('click', function () {
        mMain.src = src;
        mThumbs.querySelectorAll('.pnc-qv-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
      mThumbs.appendChild(b);
    });
    mOpts.innerHTML = '';
    setQty(1);
    chosen = (p.variants.find(function (v) { return v.available; }) || p.variants[0]).options.slice();
    if (p.variants.length > 1 && p.options) {
      p.options.forEach(function (optRaw, oi) {
        var optName = (optRaw && typeof optRaw === 'object') ? optRaw.name : optRaw;
        var values = [];
        p.variants.forEach(function (v) { if (values.indexOf(v.options[oi]) < 0) values.push(v.options[oi]); });
        var wrap = document.createElement('div'); wrap.className = 'pnc-qv-opt';
        var lbl = document.createElement('span'); lbl.className = 'pnc-qv-opt-label'; lbl.textContent = optName; wrap.appendChild(lbl);
        var row = document.createElement('div'); row.className = 'pnc-qv-pills'; row.setAttribute('role', 'group'); row.setAttribute('aria-label', optName);
        values.forEach(function (val) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'pnc-qv-pill'; b.textContent = val;
          b.setAttribute('aria-pressed', val === chosen[oi] ? 'true' : 'false');
          b.addEventListener('click', function () {
            chosen[oi] = val;
            row.querySelectorAll('.pnc-qv-pill').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            clearAdded();
            refreshCta();
          });
          row.appendChild(b);
        });
        wrap.appendChild(row); mOpts.appendChild(wrap);
      });
    }
    buildExtra(p);
    refreshCta();
    open();
  }

  /* ---- Added-to-cart: mini-cart (10s) then banner ---- */
  var SHIP_SAVE = 995; /* matches the cart page's typical domestic shipping figure */

  function clearAdded() {
    if (!addedView) return;
    addedView = false;
    var ba = modal && modal.querySelector('[data-m-added]'); if (ba) ba.hidden = true;
    refreshCta();
  }

  function renderMini(cart, vid) {
    var body = modal.querySelector('[data-m-mini-body]');
    var items = cart.items.slice();
    var ai = items.findIndex(function (i) { return String(i.variant_id) === String(vid); });
    if (ai > 0) items.unshift(items.splice(ai, 1)[0]);
    var shown = items.slice(0, 3), more = items.length - shown.length;
    var h = shown.map(function (i, n) {
      var img = i.featured_image && i.featured_image.url ? i.featured_image.url + (i.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
      var vt = i.variant_title && i.variant_title !== 'Default Title' ? esc(i.variant_title) + ' \u00d7' + i.quantity : '\u00d7' + i.quantity;
      return '<div class="pnc-qv-mline' + (n === 0 && ai > -1 ? ' is-new' : '') + '">' +
        '<div class="pnc-qv-mimg">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="pnc-qv-mname"><b>' + esc(i.product_title) + '</b><span>' + vt + '</span></div>' +
        '<b class="pnc-qv-mprice">' + money(i.final_line_price) + '</b></div>';
    }).join('');
    if (more > 0) h += '<div class="pnc-qv-mmore">+ ' + more + ' more item' + (more > 1 ? 's' : '') + ' in your cart</div>';
    h += '<div class="pnc-qv-msub"><span>Subtotal (' + cart.item_count + ' item' + (cart.item_count > 1 ? 's' : '') + ')</span><b>' + money(cart.total_price) + '</b></div>';
    var save = (cart.total_discount || 0) + SHIP_SAVE;
    h += '<p class="pnc-qv-msave">Free shipping on this order &middot; You\u2019re saving ' + money(save) + '</p>';
    body.innerHTML = h;
  }

  function showMini(cart, vid) {
    lastCart = cart;
    renderMini(cart, vid);
    mini.classList.add('is-on'); mini.setAttribute('aria-hidden', 'false');
    var bar = mini.querySelector('[data-m-bar]');
    bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
    mini.classList.remove('is-paused');
    miniLeft = 10000; miniShownAt = Date.now(); startMini();
    var c = mini.querySelector('[data-m-mini-close]'); if (c) c.focus({ preventScroll: true });
  }

  function startMini() {
    clearTimeout(miniTimer); miniStart = Date.now();
    miniTimer = setTimeout(function () { hideMini(false); }, miniLeft);
  }
  function stopMini() { clearTimeout(miniTimer); miniTimer = null; }
  var miniShownAt = 0;
  function pauseMini() {
    if (!miniTimer || Date.now() - miniShownAt < 500) return;
    stopMini(); miniLeft = Math.max(1000, miniLeft - (Date.now() - miniStart));
    mini.classList.add('is-paused');
  }
  function resumeMini() {
    if (!mini.classList.contains('is-on') || miniTimer) return;
    mini.classList.remove('is-paused'); startMini();
  }

  function hideMini(focusBack) {
    stopMini();
    if (!mini || !mini.classList.contains('is-on')) return;
    mini.classList.remove('is-on'); mini.setAttribute('aria-hidden', 'true');
    var ba = modal.querySelector('[data-m-added]');
    var n = lastCart ? lastCart.item_count : 0;
    modal.querySelector('[data-m-added-txt]').textContent = 'Added to cart' + (n ? ' \u00b7 ' + n + ' item' + (n > 1 ? 's' : '') : '');
    ba.hidden = false; addedView = true; refreshCta();
    if (focusBack && mCta && !mCta.disabled) mCta.focus({ preventScroll: true });
  }

  function addFromModal() {
    if (mCta.disabled) return;
    var vid = mCta.dataset.vid;
    if (!vid) return;
    var original = mCta.textContent;
    mCta.disabled = true; mCta.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: qty })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
    .then(function (res) {
      if (!res.ok) {
        mCta.textContent = /stock|available|all \d+/i.test((res.j && (res.j.description || res.j.message)) || '') ? 'Not enough stock' : 'Try again';
        setTimeout(function () { mCta.textContent = original; mCta.disabled = false; }, 2000);
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        mCta.disabled = false; mCta.textContent = original;
        showMini(cart, vid);
      });
    })
    .catch(function () { mCta.textContent = 'Try again'; mCta.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var qv = e.target.closest('.pnc-qv[data-handle]');
    if (!qv) return;
    e.preventDefault();
    buildModal();
    var handle = qv.getAttribute('data-handle');
    if (!handle) return;
    addedView = false; stopMini(); if (mini) mini.classList.remove('is-on'); var _ba = modal.querySelector('[data-m-added]'); if (_ba) _ba.hidden = true; qty = 1; if (mQn) mQn.textContent = 1;
    mTitle.textContent = 'Loading…'; mVendor.textContent = ''; mPrice.textContent = '';
    mDesc.innerHTML = ''; mOpts.innerHTML = ''; if (mExtra) mExtra.innerHTML = ''; mThumbs.innerHTML = ''; mMain.src = '';
    open();
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { mTitle.textContent = 'Could not load product.'; });
  });
})();
